import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  IGlobalHbUserState,
  selectConfiguration,
  selectHbContacts,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import SuccessStoriesListPage from '../components/SuccessStoriesListPage'
import {
  actionCreators,
  ISuccessStoriesListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectOrderBy,
  selectSortOrder,
  selectTotalItems,
} from '../modules/successStoriesList'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      ISuccessStoriesListState & IGlobalConfigurationState
    >({
      configuration: selectConfiguration(),
      error: selectError(),
      items: selectItems(),
      filterText: selectFilterText(),
      orderBy: selectOrderBy(),
      sortOrder: selectSortOrder(),
      totalItems: selectTotalItems(),
      isLoading: selectIsLoading(),
    }),
    actionCreators,
  )(SuccessStoriesListPage),
)
